;(function() {
  'use strict'

  directive.$inject = ["$state", "configService"];
  angular.module('core.topbar').directive('topbar', directive)

  /* @ngInject */
  function directive($state, configService) {
    controller.$inject = ["$scope", "$state", "app", "configService", "userService", "statsService", "locationService", "searchService", "searchTermsService"];
    var SEARCH_THRESHOLD = 3

    var Keys = {
      UP: 38,
      DOWN: 40,
      ESCAPE: 27,
      ENTER: 13,
    }

    var States = {
      IDLE: 'idle',
      LOADING: 'loading',
      RESULTS: 'results',
      NONE: 'none',
      ERROR: 'error',
    }

    var queryRedirects = {
      Staging: [
        {
          query: '#trybarcounter',
          stateName: 'app.survey',
          stateParams: {
            id: '6052c58c-a932-4056-85c4-df3b4fb5fa27',
          },
        },
      ],
      Production: [
        {
          query: '#trybarcounter',
          stateName: 'app.survey',
          stateParams: {
            id: '8f6d1170-d1d3-44d3-9f3c-a8a4269ac15a',
          },
        },
      ],
    }
    queryRedirects = queryRedirects[configService.getBuildEnv()] || []

    return {
      restrict: 'E',
      scope: {
        query: '=?',
        onState: '&?',
      },
      templateUrl: 'topbar.template.html',
      controller: controller,
      link: link,
    }

    /* @ngInject */
    function controller(
      $scope,
      $state,
      app,
      configService,
      userService,
      statsService,
      locationService,
      searchService,
      searchTermsService
    ) {
      var requestNum = 0
      var lazySearch = _.debounce(search, 700)

      $scope.stats = statsService.get()
      $scope.user = userService.get()
      $scope.suggestions = {}

      $scope.onSearchEnter = onSearchEnter
      $scope.onQueryChange = onQueryChange
      $scope.onClickSuggestion = onClickSuggestion

      $scope.toggleMenu = toggleMenu
      $scope.promptLogin = promptLogin
      $scope.showNearby = showNearby

      $scope.logout = logout

      $scope.$on('use-location', enableLocation)

      // immediate search if past threshold and not a hashtag
      if ($scope.query && $scope.query.length >= SEARCH_THRESHOLD) {
        search($scope.query)
      }

      // immediate search if nearby clicked
      if ($state.params.nearby) {
        showNearby()
      }

      function onSearchEnter(query) {
        modifyQuery(query, true)
      }

      function onQueryChange(query) {
        modifyQuery(query, false)
      }

      function onClickSuggestion(suggestion) {
        modifyQuery(suggestion.query, true)
      }

      function modifyQuery(query, userActioned) {
        // go to search page if not already
        if (!isSearchState()) {
          return goSearchState(query)
        }

        // cancel/reset any existing searches
        resetSearch()

        // set query incase it isn't already
        $scope.query = query

        // update the url to reflect the new search
        updateUrl(query)

        // if user hit enter, clicked the search button, or clicked a suggestion
        if (userActioned) {
          // handle any redirects and if any, dont continue searching
          if (handleRedirect(query)) {
            return
          }

          // otherwise search immediately
          return search(query)
        }

        // display any suggestions
        updateSuggestions(query)

        // start a lazy search if we can
        if (isPastQueryThreshold(query) && !isHashtagQuery(query)) {
          lazySearch(query)
        }
      }

      function handleRedirect(query) {
        // query redirects
        var redirect = _.find(queryRedirects, { query: query })
        if (redirect) {
          searchTermsService.create(query, redirect.stateName)
          $state.go(redirect.stateName, redirect.stateParams, {
            location: 'replace',
          })
          return true
        }
        // glow links
        if (isGlowLink(query)) {
          var prefix = '//'
          window.location.href = prefix + query
          return true
        }
      }

      function resetSearch() {
        lazySearch.cancel()
        requestNum++
        setState(States.IDLE)
        updateSuggestions(null)
      }

      function isGlowLink(query) {
        var str = query && query.toLowerCase()
        return (
          _.startsWith(str, 'glo.link/') ||
          _.startsWith(str, 'staging.glo.link/')
        )
      }

      function isHashtagQuery(query) {
        return _.startsWith(query, '#')
      }

      function isPastQueryThreshold(query) {
        return query.length >= SEARCH_THRESHOLD
      }

      function isSearchState() {
        return $state.current.name === 'app.search'
      }

      function goSearchState(query) {
        $state.go('app.search', { query: query })
      }

      function updateUrl(query) {
        var params = _.extend($state.params, { query: query, nearby: null })
        $state.go($state.current.name, params, {
          reload: false,
          location: 'replace',
          notify: false,
        })
        app.setTitle('Search')
      }

      function enableLocation() {
        setState(States.LOADING)
        locationService.get(true).finally(function() {
          search($scope.query)
        })
      }

      function showNearby() {
        var stateName = $state.current.name
        var stateParams = $state.params

        // go to search state
        if (stateName !== 'app.search') {
          return $state.go('app.search', { nearby: true })
        }

        // otherwise update url
        $state.go(
          stateName,
          _.extend(stateParams, { query: null, nearby: true }),
          {
            reload: false,
            // location: 'replace',
            notify: false,
          }
        )
        app.setTitle('Nearby')

        // and do nearby search
        setState(States.LOADING)
        locationService.get(true).then(
          function() {
            $scope.query = null
            search()
          },
          function() {
            search($scope.query)
          }
        )
      }

      function updateSuggestions(query) {
        // hide if not in threshold
        if (!query || query.length < SEARCH_THRESHOLD) {
          $scope.suggestions.visible = false
          $scope.suggestions.selected = null
          return
        }

        // otherwise find matches
        searchTermsService.search(query).then(
          function(matches) {
            $scope.suggestions.matches = matches
            $scope.suggestions.visible = true
          },
          function() {
            $scope.suggestions.visible = false
            $scope.suggestions.selected = null
          }
        )
      }

      function toggleMenu(e) {
        e.stopPropagation()

        if ($scope.menuVisible) {
          closeMenu()
        } else {
          openMenu()
        }
      }

      function openMenu() {
        $scope.$applyAsync(function() {
          $scope.menuVisible = true
          document.body.addEventListener('click', closeMenu)
        })
      }

      function closeMenu() {
        $scope.$applyAsync(function() {
          $scope.menuVisible = false
          document.body.removeEventListener('click', closeMenu)
        })
      }

      function promptLogin() {
        userService.promptLogin('Login or Signup to Glowfeed')
      }

      function search(query) {
        var options = {}
        var reqNum = ++requestNum
        var hashtagSearch = isHashtagQuery(query)
        var nearbySearch = !!$state.params.nearby

        if (nearbySearch) {
          options.type = searchService.Types.PLACE
        } else if (hashtagSearch) {
          options.type = searchService.Types.PAGE
        } else {
          options.type = searchService.Types.ALL
        }

        setState(States.LOADING)
        searchService.search(query, options).then(
          function(results) {
            // do nothing if another search started after this one
            if (reqNum !== requestNum) {
              return
            }

            // check for hash and hash matches if needed
            if (hashtagSearch && results.length) {
              var lowercaseQueryWithoutHash = query.substr(1).toLowerCase()
              var match = _.find(results, function(result) {
                return (
                  result.type === 'page' &&
                  _.includes(result.hashTags, lowercaseQueryWithoutHash)
                )
              })

              // if hashtag matches, go directly to page (DO NOT PASS GO, DO NOT COLLECT $200)
              if (match) {
                searchTermsService.create(query, match.type)
                $state.go(
                  'app.page',
                  { id: match.pageId },
                  { location: 'replace' }
                )
              }
            }

            if (results.length) {
              setState(States.RESULTS, results)
            } else {
              setState(States.NONE)
            }
          },
          function() {
            setState(States.ERROR)
          }
        )
      }

      function setState(state, results) {
        if ($scope.onState) {
          $scope.$applyAsync(function() {
            $scope.onState({ $state: state, $results: results })
          })
        }
      }

      function logout() {
        userService.logout().then(function() {
          $state.go('app.public')
        })
      }
    }

    function link(scope, elem) {
      var input
      var onResize = _.throttle(calcAutocompletePosition, 300)

      elem.addClass('topbar')

      // search - if visible grab a reference focus item
      if ($state.current.name === 'app.search') {
        input = angular.element(
          angular.element(elem)[0].querySelector('input')
        )[0]

        // focus input if user hasnt hit threshold
        if (scope.query && scope.query.length < 3) {
          input.focus()
        }

        // autocomplete - precalculate the position it will pop up
        calcAutocompletePosition()
      }

      // listeners - setup
      document.body.addEventListener('resize', onResize)
      document.body.addEventListener('keydown', onKeyDown)
      document.body.addEventListener('click', onClick)

      // listeners - cleanup
      scope.$on('$destroy', function() {
        document.body.removeEventListener('resize', onResize)
        document.body.removeEventListener('keydown', onKeyDown)
        document.body.removeEventListener('click', onClick)
      })

      function calcAutocompletePosition() {
        if (!input) {
          return
        }
        scope.$applyAsync(function() {
          var bounds = input.getBoundingClientRect()
          scope.suggestions.width = input.clientWidth + 'px'
          scope.suggestions.top = bounds.top + input.clientHeight + 'px'
          scope.suggestions.left = bounds.left + 'px'
        })
      }

      function onKeyDown(e) {
        var suggestions = scope.suggestions

        // stop if we arent trying to traverse the suggestions
        if (
          !input ||
          document.activeElement !== input ||
          !suggestions.visible ||
          !suggestions.matches.length
        ) {
          return
        }

        if (e.keyCode === Keys.DOWN) {
          e.preventDefault()
          scope.$applyAsync(function() {
            // select first if nothing selected
            if (!_.isNumber(suggestions.selected)) {
              suggestions.selected = 0

              // select one below if there is one
            } else if (suggestions.selected < suggestions.matches.length - 1) {
              suggestions.selected++

              // select none if this is the last one
            } else {
              suggestions.selected = null
            }

            // update input query
            if (_.isNumber(suggestions.selected)) {
              scope.query = suggestions.matches[suggestions.selected].query
            }
          })
        }

        if (e.keyCode === Keys.UP) {
          e.preventDefault()
          scope.$applyAsync(function() {
            // select last if nothing selected
            if (!_.isNumber(suggestions.selected)) {
              suggestions.selected = suggestions.matches.length - 1

              // select one above if there is one
            } else if (suggestions.selected > 0) {
              suggestions.selected--

              // select none if this is the top
            } else {
              suggestions.selected = null
            }

            // update input query
            if (_.isNumber(suggestions.selected)) {
              scope.query = suggestions.matches[suggestions.selected].query
            }
          })
        }

        if (e.keyCode === Keys.ESCAPE) {
          scope.$applyAsync(function() {
            suggestions.visible = false
            suggestions.selected = null
          })
        }
      }

      function onClick(e) {
        if (scope.suggestions.visible) {
          // pressing enter in search input triggers click on submit button
          // so we dont want to stop bubbling
          if (e.target.id !== 'search-btn') {
            e.preventDefault()
            e.stopPropagation()
            e.stopImmediatePropagation()
          }

          scope.$applyAsync(function() {
            scope.suggestions.visible = false
            scope.suggestions.matches = null
            scope.suggestions.selected = null
          })
        }
      }
    }
  }
})()
